// extracted by mini-css-extract-plugin
export default {"card":"ContactForm_card__m5jb0","form":"ContactForm_form__M8bRI","control":"ContactForm_control__iBjpk","actions":"ContactForm_actions__hkpyh"};